import { useEffect, useState } from "react";
import Category from "./Category";
import RangeOfDate from "./RangeOfDate";
import "./ReportData.css";
import {
  fetchOrgName,
  getAllUsers,
  getExcelDataReport,
} from "../../../config/LiveApi";
import PayInReportExcel from "./PayInReportExcel";
import PayoutReportExcel from "./PayoutReportExcel";
import Spinner from "../../Spin/Spinner";
import { useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import DataType from "./DateType";

function MainReport() {
  let token = useSelector((store) => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);
  const [loading, setLoading] = useState(false);
  const [orgList, setOrgList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [typeData, setTypeData] = useState("");
  const [typeDate, setTypeDate] = useState("");
  const [allData, setAllData] = useState(null);
  const [dummyStartDate, setDummyStartDate] = useState(null);
  const [dummyEndDate, setDummyEndDate] = useState(null);
  const [org, setOrg] = useState(null);
  const [user, setUser] = useState(null);
  const [orgOptions, setOrgOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  // const dataRequest = async (
  //   token,
  //   startDate,
  //   endDate,
  //   typeData,
  //   role,
  //   orgName,
  //   setLoading
  // ) => {
  //   setLoading(true);
  //   const data = await getExcelDataReport(
  //     token,
  //     startDate,
  //     endDate,
  //     typeData,
  //     orgName,
  //     role
  //   );
  //   console.log("data", data);
  //   toast.success(data?.message);
  //   // setTimeout(() => {
  //   //   window.location.reload();
  //   // }, 5000);
  //   setAllData(data?.payin_and_rolling_reserve_and_admin_comm);
  //   setLoading(false);
  // };

  const dataRequest = async (
    token,
    startDate,
    endDate,
    typeData,
    role,
    typeDate,
    orgName,
    setLoading
  ) => {
    try {
      setLoading(true);
      const data = await getExcelDataReport(
        token,
        startDate,
        endDate,
        typeData,
        typeDate,
        orgName,
        user?.value
      );

      toast.success(data?.message || "Data fetched successfully");
      setAllData(data?.payin_and_rolling_reserve_and_admin_comm);

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch data";

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (role === 'admin' || role === 'subAdmin')
      setOrg([])
  }, [])

  useEffect(() => {
    const now = new Date();

    now.setHours(0, 0, 0, 0);
    const isoDateString = now.toISOString();

    const nowDays = new Date();
    const isoDateCurrent = nowDays.toISOString();

    setStartDate(isoDateString);
    setEndDate(isoDateCurrent);
    const today = new Date();


    const formattedDate = today.toISOString().slice(0, 10);
    setDummyStartDate(formattedDate);
    setDummyEndDate(formattedDate);
  }, []);

  const handleOrgChange = (selection) => {
    setOrg(selection);
    setUser(null);

  };
  const handleUserChange = (selection) => {
    setUser(selection);
    setOrg(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (role === "admin" || role === "mops" || role === "subAdmin") return;
        const response = await fetchOrgName("", token);
        const responseUser = await getAllUsers(token, 1);

        setOrgList(response.data);
        setUserList(responseUser.data);
      } catch (error) {
        console.error("Error fetching organization name:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const processOrgList = () => {
      const myData = orgList.map((item) => ({
        value: item.id,
        label: item.orgName,
      }));
      setOrgOptions(myData);
    };

    processOrgList();
    const processUserList = () => {
      const userData = userList
        .filter((item) => item.role === "admin")
        .map((item) => ({
          value: item.id,
          label: item.alias || item.id,
        }));
      setUserOptions(userData);
    };

    processUserList();
  }, [orgList, userList]);

  return (
    <>
      <h5 className="area-top-title ">Generate Report</h5>
      <p>
        To Generate Report, first select your desired <b>organization</b> then{" "}
        <b>check the box</b> and &nbsp;select <b>date range</b>, click on the{" "}
        <b>get data</b>
        &nbsp;button. Once <b>Download</b> Button appears, you will be able to
        download the report.
      </p>

      {(role === "super" || role === "operation" || role === "accounts") && (
        <Select
          className="report-org-dropdown"
          value={org}
          options={orgOptions}
          placeholder="Select Organization..."
          onChange={handleOrgChange}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
      )}
      {(role === "super" || role === "operation" || role === "accounts") && (
        <p style={{ textAlign: "Center", paddingTop: "15px" }}>OR</p>
      )}
      {(role === "super" || role === "operation" || role === "accounts") && (
        <Select
          className="report-org-dropdown report-mer-dropdown"
          value={user}
          options={userOptions}
          placeholder="Select Merchant..."
          onChange={handleUserChange}
        />
      )}

      {loading ? (
        <Spinner />
      ) : (
        (org || user || role === "mops") && (
          <div className="upper-div-rep">
            <div className="div-gap">
              <DataType setTypeDate={setTypeDate} typeDate={typeDate} />
            </div>
            <div className="div-gap">
              <Category setTypeData={setTypeData} typeData={typeData} />
            </div>

            <div className="div-gap">
              <RangeOfDate
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                startDate={startDate}
                endDate={endDate}
                dummyStartDate={dummyStartDate}
                dummyEndDate={dummyEndDate}
                setDummyStartDate={setDummyStartDate}
                setDummyEndDate={setDummyEndDate}
              />
            </div>
            {/* <div className='div-gap'>


      <FeildsData/>
      </div> */}

            <div className="exp-div1">
              {allData &&
                allData.length > 0 &&
                (typeData == "Payin" ? (
                  <PayInReportExcel allData={allData} fileName="PayIn" />
                ) : typeData == "Payout" ? (
                  <PayoutReportExcel allData={allData} fileName="PayOut" />
                ) : (
                  ""
                ))}

              {typeData && (
                <button
                  className="exp-but"
                  onClick={() =>
                    dataRequest(
                      token,
                      startDate,
                      endDate,
                      typeData,
                      role,
                      typeDate,
                      org?.label,
                      setLoading
                    )
                  }
                >
                  Generate Report
                </button>
              )}
            </div>
          </div>
        )
      )}
    </>
  );
}

export default MainReport;